<template>
  <div class="mall">
    <div class="mallTop">
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        :show-indicators="false"
      >
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.image" style="width: 100%; height: 150.5px" />
          <!-- <img src="../../assets/imgs/home/img1.png" style="width: 100%; height: 150.5px" /> -->
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="notice-title" @click="$router.push('notice')">
      <img src="../../assets/imgs/home/notice.png" class="noticeImg" />
      <div class="title">
        <van-notice-bar :scrollable="false">
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item v-for="item in noticeList" :key="item.id">{{
              item.title
            }}</van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
    >
      <!-- 商品 -->
      <div class="shop-content">
        <div
          class="shop-nav"
          @click="
            $router.push({ path: 'goodsDetails', query: { id: item.id } })
          "
          v-for="(item, index) in goodsList"
          :key="index"
        >
          <img :src="item.image" />
          <div class="goodsBtm">
            <div class="goodsName textEllipsis-2">{{ item.name }}</div>
            <div class="goodsDesc">
              <div class="goodsPrice">
                ￥
                <span>{{ item.price }}</span>
              </div>
              <!-- <div class="goodsVolume priceBefore" v-if='item.rank_price!=item.price'>
                ￥
                <span>{{ item.price }}</span>
              </div> -->
              <!-- <div class="goodsVolume" >{{ item.sales }}人付款</div> -->
            </div>
            <!-- <div class="shop-but">立即购买</div> -->
          </div>
        </div>
      </div>
    </van-list>
    <!-- 是否有审核的 -->
    <van-dialog
      v-model="noticeShow"
      title="通知"
      :close-on-click-overlay="true"
      @confirm="confirmNotice"
    >
      <div class="countWrap">
        您好，您有<span>{{ noticeCount }}</span
        >个新的团队订单，请注意查看
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  bannerList,
  noticeList,
  cateList,
  goodsList,
  rankList,
} from "@/api/home";
import { userInfo, confirmOrder } from "@/api/personal";
export default {
  data() {
    return {
      noticeShow: false,
      noticeCount: 0,
      bannerList: [],
      noticeList: [],
      adImg: "",
      adUrl: "", //广告位
      active: 0,
      showwr: false,
      loading: false,
      finished: true,
      shedialog: false,
      hotgoods: {},
      cateList: [],
      xitonglist: {},
      money: "",
      mesarr: {},
      loadTag: 1,
      form: {
        page: 1,
        pagesize: 10,
        category_id: 0,
      },
      goodsList: [],
      count: "",
      rankOne: {},
      rankTwo: {},
    };
  },
  created() {
    userInfo().then((res) => {
      if (res.is_new_order > 0) {
        this.noticeShow = true;
        this.noticeCount = res.is_new_order;
      }
    });
    // 轮播图
    bannerList(1).then((res) => {
      this.bannerList = res;
    });
    noticeList().then((res) => {
      this.noticeList = res;
    });
    // 广告位
    bannerList(2).then((res) => {
      this.adImg = res[0].image;
      this.adUrl = res[0].url;
    });
    rankList().then((res) => {
      this.rankOne = res[1];
      this.rankTwo = res[2];
    });
    cateList().then((res) => {
      this.cateList = res;
      this.cateList.unshift({
        name: "全部",
        id: "0",
      });
      this.form.category_id = res[0].id;
      this.onLoad();
    });
  },
  methods: {
    // 通知确认
    confirmNotice() {
      confirmOrder().then((res) => {
        this.$router.push({
          path: "myOrder",
          query: { typeActive: 1, active: 1 ,status:2},
        });
      });
    },
    getcate(item) {
      this.form.category_id = item.id;
      this.form.page = 1;
      this.goodsList = [];
      this.onLoad();
    },
    onLoad() {
      goodsList(this.form).then((resp) => {
        this.form.page++;
        let rows = resp.data;
        this.count = resp.count;
        this.loading = false;
        this.finished = false;
        if (rows == null || rows.length == 0) {
          this.finished = true;
          return;
        }
        this.goodsList = this.goodsList.concat(rows);
        if (this.goodsList.length >= this.count) {
          this.finished = true;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mall {
  padding-bottom: 70px;
  background: #f7fbff;
}
.mallTop {
  width: 100%;
  height: 220px;
  background: url("../../assets/imgs/home/homeBg.png") 0 0 no-repeat;
  background-size: 100% 100%;
  padding-top: 45px;
  box-sizing: border-box;
}

.my-swipe {
  width: 345px;
  height: 150px;
  margin: 12px auto 13.5px;
}

.mark {
  width: 100%;
  height: 100%;
  background: black;
  z-index: 99;
  opacity: 0.4;
  position: fixed;
  left: 0;
  top: 0;
}
.priceBefore {
  text-decoration: line-through;
}
/deep/.van-list__finished-text {
  background: white;
}

.shop-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 0 12px;

  .shop-nav {
    width: 49%;
    border-radius: 8px;
    background: #fff;
    margin-top: 7.5px;
    border-bottom: 1px solid rgba(146, 146, 146, 0.35);
    font-size: 14px;
    position: relative;

    img {
      width: 100%;
      height: 157.5px;
      border-radius: 8px 8px 0 0;
    }

    .goodsBtm {
      padding: 0 11px 22.5px;
      box-sizing: border-box;

      .shop-but {
        width: 80px;
        text-align: center;
        background: #ff6187;
        color: white;
        margin: 10px 0;
        float: right;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        border-radius: 15px;
        padding: 0;
        text-align: center;
      }
    }

    .goodsName {
      height: 38px;
      color: #333;
    }
  }
}

.notice-title {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 347px;
  height: 37px;
  padding: 0 13px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0 3px rgba(51, 102, 255, 0.19);
  margin: 0 auto;
  border-radius: 18.5px;

  .noticeImg {
    width: 20px;
    height: 20px;
  }

  .title {
    width: 90%;

    .van-notice-bar {
      width: 90%;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      color: #333;
      border-radius: 15px;
      background: #fff;

      /deep/.van-ellipsis {
        height: 100%;
        width: 100%;

        .notice-swipe {
          width: 100%;
          height: 100%;
        }

        .van-swipe {
          height: 100%;
        }

        .van-swipe-item {
          height: 100%;
        }
      }
    }
  }
}

/deep/ [class*="van-hairline"]::after {
  border: 0 none;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  border-bottom: 1px solid #d3d3d3;
}

.goodsDesc {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  align-items: center;
  .goodsPrice {
    color: #ff6187;
  }

  .goodsVolume {
    color: #666;
    font-size: 13px;
  }
}
.countWrap {
  padding: 10px 0;
  font-size: 14px;
  box-sizing: border-box;
  text-align: center;
  color: #666;
  span {
    color: red;
  }
}
</style>